import { observable, action, runInAction } from 'mobx';
import * as filestack from 'filestack-js';
import axios from "axios";
import { toast } from "react-toastify"
import IDocument, { IDocumentFilter, IDocumentCollection, newDocFilterInstance } from '../types/IDocument';
import IDocumentService from '../services/spi/IDocumentService';
import FirebaseDocumentService from '../services/impl/firebase/FirebaseDocumentService';

import IPaginator, { IPaginatorQueryType, newPaginatorInstance } from '../types/Paginator';
import { IActivityCollection, newActivityFilterInstance } from '../types/IActivity';
import IActivityService from '../services/spi/IActivityService';
import FirebaseActivityService from '../services/impl/firebase/FirebaseActivityService';
import FirebaseService from '../services/impl/firebase/FirebaseService';
import IMeeting from '../types/IMeeting';


const ROWS_PER_PAGE = 6;
class DashboardStore {
    rootStore:any = null;
    
    documentFilter = undefined as IDocumentFilter | undefined;
    documentService = {} as IDocumentService;
    activityService = {} as IActivityService;
    @observable documentCollection:IDocumentCollection = {
      documents: [],
      paginator: newPaginatorInstance()
    };
    @observable activitiesCollection: IActivityCollection = {
      activities : [],
      paginator: newPaginatorInstance()
    }
    @observable todayMeetings:any = {};

  constructor(rootStore:any) {
    this.rootStore = rootStore;
    this.documentService = new FirebaseDocumentService();
    this.activityService = new FirebaseActivityService();
  }

  @action fetchMeetings = ( uid:string, date:any) => {

    const midNightDate = date;
    const nextMidNightDate = new Date(date);
    midNightDate.setHours(0,0,0,0);
    nextMidNightDate.setHours(24,0,0,0);
    FirebaseService.getInstance()
      .meetings(uid)
      .orderByChild('startTime')
      .startAt(midNightDate.getTime())
      .limitToFirst(5)
      .on('value', (snapshot:any) => {
        snapshot.forEach((meeting:any) => {
          let mkey = meeting.key
          let val = meeting.val()
          if (midNightDate.getTime() < meeting.val().startTime && meeting.val().startTime < nextMidNightDate.getTime()) {
            this.todayMeetings[mkey] = val
          }
        });
      });
  }

  @action setDocumentFilter(filter?:IDocumentFilter){
    if(filter == undefined){
      this.documentFilter = undefined;
    }else {
      this.documentFilter = Object.assign(this.documentFilter || {}, filter);
    }
  }

  @action loadDocuments = async () => {
    try{
        this.documentCollection = await this.documentService.getDocuments(newPaginatorInstance(6), newDocFilterInstance());    
      }catch(e){
        debugger;
        toast.error("Error loading documents. ");
      }
  }

  @action loadActivities = async () => {
    try{
      this.activitiesCollection = await this.activityService.getActivities(newPaginatorInstance(4), newActivityFilterInstance());    
    }catch(e){
      debugger;
      toast.error("Error loading documents. ");
    }
  }

}

export default DashboardStore;